<template>
  <div class="pa-10">
    <ManageInternDataTable />
  </div>
</template>

<script>
import ManageInternDataTable from "@/components/Utils/ManageInternDataTable.vue";
export default {
  components: {
    ManageInternDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
